import { UserPayload, UserPropsResult } from '../types';

export const mapUserProps = (payload: UserPayload): UserPropsResult => ({
    device_manufacturer: payload.deviceManufacturer,
    device_platform: payload.platform,
    app_version: payload.appVersion,
    device_platform_version: payload.osVersion,
});
